import Vue from 'vue'
import Vuex from 'vuex'
import { poem } from '../store/modules/poem'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    poem
  }
})
